import { CircularProgress, RaisedButton } from "material-ui";
import * as TimeUtils from "../../../../general/time-utils";
import { DS } from "../../../../theme-default";

const React = require("react");

export default class UserApprovalRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true
    };
  }

  render() {
    let state = "Aprobat";
    if (!this.props.allApproved) {
      if (this.props.approved === undefined || this.props.approved === null) {
        state = "";
      } else if (!this.props.approved) {
        state = "Respins";
      }
    }
    // An info step fills lines (shown in the paper's details) and never approves or rejects.
    if (this.props.infoStep && this.props.approved === true) {
      state = "Completat";
    }

    return (
      <tr>
        <td>
          <div
            style={{
              maxWidth: "150px",
              wordWrap: "break-word"
            }}
          >
            {this.props.calling}
          </div>
        </td>
        <td>{this.props.firstName}</td>
        <td>{this.props.lastName}</td>
        <td>
          {this.props.email}
          {this.props.fallbackNames && (
            <div style={{ color: DS.textMuted, fontSize: "12px" }}>
              Înlocuitori: {this.props.fallbackNames}
            </div>
          )}
        </td>
        <td>
          {state === "" && this.props.canApprove ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "nowrap",
                whiteSpace: "nowrap"
              }}
            >
              {this.props.showApprovingProgress && (
                <CircularProgress size={24} />
              )}
              <RaisedButton
                disabled={this.props.showApprovingProgress}
                primary
                label={this.props.infoStep ? "Salvează" : "Aproba"}
                onClick={() =>
                  this.props.onApprove(
                    this.props.paper,
                    this.props.orderNumber
                  )
                }
              />
              {!this.props.infoStep && (
                <RaisedButton
                  disabled={this.props.showApprovingProgress}
                  secondary
                  label={"Respinge"}
                  onClick={() =>
                    this.props.onReject(
                      this.props.paper,
                      this.props.orderNumber
                    )
                  }
                />
              )}
            </div>
          ) : (
            state
          )}
        </td>
        <td>{this.props.date && TimeUtils.getAprovalDateFormat(this.props.date)}</td>
      </tr>
    );
  }
}
